const companies = [
  { name: "dokan", icon: "ri-store-2-line" },
  { name: "travelcierge", icon: "ri-plane-line" },
  { name: "hopin", icon: "ri-broadcast-line" },
  { name: "vista", icon: "ri-eye-line" },
  { name: "shippo", icon: "ri-ship-line" },
  { name: "magnolia", icon: "ri-flower-line" },
];

function LogoItem({ company }: { company: { name: string; icon: string } }) {
  return (
    <div className="flex items-center gap-2 opacity-50 hover:opacity-80 transition-opacity duration-200 cursor-pointer grayscale hover:grayscale-0 flex-shrink-0 px-6">
      <div className="w-5 h-5 flex items-center justify-center">
        <i className={`${company.icon} text-lg`} />
      </div>
      <span className="text-base font-bold text-gray-800 tracking-tight whitespace-nowrap">{company.name}</span>
    </div>
  );
}

export default function TrustSection() {
  // Duplicate the list 4x for a seamless infinite loop
  const items = [...companies, ...companies, ...companies, ...companies];

  return (
    <section className="py-12 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-4">
        <p className="text-xs font-bold tracking-[0.15em] uppercase text-gray-400 text-center md:text-left">
          Trusted by innovative companies
        </p>
      </div>

      {/* Marquee container */}
      <div className="relative w-full overflow-hidden">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-20 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to right, white, transparent)" }} />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-20 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to left, white, transparent)" }} />

        {/* Scrolling track */}
        <div className="flex items-center animate-marquee hover:[animation-play-state:paused]">
          {items.map((company, i) => (
            <LogoItem key={`${company.name}-${i}`} company={company} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
          will-change: transform;
        }
      `}</style>
    </section>
  );
}
